import { render, staticRenderFns } from "./CopyrightComponent.vue?vue&type=template&id=18751810&scoped=true&"
import script from "./CopyrightComponent.vue?vue&type=script&lang=ts&"
export * from "./CopyrightComponent.vue?vue&type=script&lang=ts&"
import style0 from "./CopyrightComponent.vue?vue&type=style&index=0&id=18751810&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18751810",
  null
  
)

export default component.exports